import { Link } from "react-router-dom";

export default function FeaturedSection() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20wide%20stylized%20illustration%20of%20a%20reader%20sitting%20comfortably%20reading%20manga%20on%20a%20tablet%20surrounded%20by%20floating%20comic%20panels%20and%20books%2C%20warm%20cozy%20coral%20amber%20and%20teal%20palette%2C%20inviting%20reading%20atmosphere%2C%20clean%20flat%20illustration%20style%2C%20high%20detail&width=1400&height=560&seq=home-cta&orientation=landscape"
              alt="追更指南主题插画"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 to-background-950/50"></div>
          </div>

          <div className="relative flex w-full flex-col items-start justify-between gap-6 px-6 py-12 md:flex-row md:items-center md:px-12">
            <div className="max-w-lg">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-500/20 px-3 py-1 text-xs font-bold text-secondary-300">
                <i className="ri-lightbulb-flash-fill" aria-hidden="true"></i>
                追更指南
              </span>
              <h2 className="mt-3 font-heading text-2xl leading-snug text-background-50 md:text-3xl">第一次选漫画软件应用？看这篇新手避坑指南</h2>
              <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
                从题材、付费意愿到使用习惯，一步步帮你找到最适合自己的漫画软件应用，避开常见坑。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/reviews/beginners-guide"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400"
              >
                阅读指南
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/faq"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border-2 border-background-50/70 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
              >
                查看常见问题
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}